import { TbIcons } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const AllItemsIcon = (props: IconProps) => {
  return <IconBase icon={TbIcons} {...props} />;
};
